module.exports = __webpack_public_path__ + "img/avatar-0.a8b410c6.png";